import { createAction } from '@reduxjs/toolkit';
import openPositionsSlice from './slice';

export const { setPositions, setPosition } = openPositionsSlice.actions;

export const fetchPositions = createAction('openPositions/fetchPositions');
export const fetchPosition = createAction('openPositions/fetchPosition');
